import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SESSION_EXPIRED_EVENT } from "../../services/apiClient";
import { useErrorStore } from "../../store/errorStore";

// Один на всё приложение: ловит протухшую сессию и уводит на вход средствами
// роутера, запомнив страницу, с которой пользователя выбросило. Так вместо
// молчаливой перезагрузки человек видит объяснение и возвращается туда, где был.
function SessionExpiryHandler() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleSessionExpired = (event: Event) => {
      const from = (event as CustomEvent<{ from?: string }>).detail?.from;
      useErrorStore.getState().setError("Сессия истекла — войдите снова, пожалуйста");

      // Уже на форме входа — объяснение показали, но второй раз никуда не
      // ведём, чтобы не затереть сохранённый адрес возврата адресом формы.
      if (window.location.pathname === "/auth") return;

      navigate("/auth", { state: from ? { from } : undefined, replace: true });
    };

    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired);
  }, [navigate, location.pathname]);

  return null;
}

export default SessionExpiryHandler;
